module.exports = __webpack_public_path__ + "img/qianfen.df085a70.jpg";